import { type PropsWithChildren, createContext, useState } from "react";
import type {CostRateTypeFromDomain,GenListType,InternalOrderDef,LookupRelations,LookupRelationshipByKey} from "../types";

type Lookups = {
  contractorsList: GenListType[];
  equipmentTypeList: GenListType[];
  ticketStatusList: GenListType[];
  forestAreaList: GenListType[];
  resourceTypeList: GenListType[];
  costCenterList: GenListType[];
  //costActivityList: GenListType[];
  costRateTypeList: CostRateTypeFromDomain[];
  costRateUnitList: GenListType[];
  genericRelationsList: LookupRelations[];
  workPerformedRelationsList: LookupRelationshipByKey[];

//  internalOrderList: InternalOrderDef[];

};

type AppContextType = {
  lookups: Lookups;
  setLookups: (data: Partial<Lookups>) => void;
};

export const AppContext = createContext<AppContextType | undefined>(undefined);

export const LookupContextProvider = ({ children }: PropsWithChildren<{}>) => {
  const [lookups, setLookupsState] = useState<Lookups>({
    contractorsList: [],
    equipmentTypeList: [],
    ticketStatusList: [],
    forestAreaList: [],
    resourceTypeList: [],
    costCenterList: [],
    //costActivityList: [],
    costRateTypeList: [],
    costRateUnitList: [],
    genericRelationsList: [],
    workPerformedRelationsList: [],
    //internalOrderList: [],
  });

  // merge updates instead of replacing the whole object
  const setLookups = (data: Partial<Lookups>) => {
    setLookupsState(prev => ({ ...prev, ...data }));
  };

  return (
    <AppContext.Provider value={{ lookups, setLookups }}>
      {children}
    </AppContext.Provider>
  );
};
